const categoryTypes = {
	ACTIVES: {
		REQUEST: 'CATEGORY_ACTIVES_REQUEST',
		SUCCESS: 'CATEGORY_ACTIVES_SUCCESS',
		FAILURE: 'CATEGORY_ACTIVES_FAILURE',
		CLEAR: 'CATEGORY_ACTIVES_CLEAR',
	},
	SUB_CATEGORIES: {
		REQUEST: 'CATEGORY_SUB_CATEGORIES_REQUEST',
		SUCCESS: 'CATEGORY_SUB_CATEGORIES_SUCCESS',
		FAILURE: 'CATEGORY_SUB_CATEGORIES_FAILURE',
		CLEAR: 'CATEGORY_SUB_CATEGORIES_CLEAR',
	},
	DYNAMIC_ATTRIBUTES: {
		REQUEST: 'CATEGORY_DYNAMIC_ATTRIBUTES_REQUEST',
		SUCCESS: 'CATEGORY_DYNAMIC_ATTRIBUTES_SUCCESS',
		FAILURE: 'CATEGORY_DYNAMIC_ATTRIBUTES_FAILURE',
		CLEAR: 'CATEGORY_DYNAMIC_ATTRIBUTES_CLEAR',
	},
	TAGS: {
		REQUEST: 'CATEGORY_TAGS_REQUEST',
		SUCCESS: 'CATEGORY_TAGS_SUCCESS',
		FAILURE: 'CATEGORY_TAGS_FAILURE',
		CLEAR: 'CATEGORY_TAGS_CLEAR',
	},
	RECOMMONED: {
		REQUEST: 'RECOMMONED_CATEGORY_TAGS_REQUEST',
		SUCCESS: 'RECOMMONED_CATEGORY_TAGS_SUCCESS',
		FAILURE: 'RECOMMONED_CATEGORY_TAGS_FAILURE',
		CLEAR: 'RECOMMONED_CATEGORY_TAGS_CLEAR',
	},
};

export default categoryTypes;
